/**
 * Figure out if the current element has a next sibling.
 * If so, moving focus to it.
 * @param {HTMLElement} parent
 * @param {string} target
 */
export function focusNextItem (parent, target) {
  const item = document.activeElement
  if (item.nextElementSibling && !item.nextElementSibling.hasAttribute('disabled')) {
    activate(parent, target, item.nextElementSibling)
  }
}

/**
 * Figure out if the current element has a previous sibling.
 * If so, moving focus to it.
 * @param {HTMLElement} parent
 * @param {string} target
 */
export function focusPreviousItem (parent, target) {
  const item = document.activeElement
  if (item.previousElementSibling && !item.previousElementSibling.hasAttribute('disabled')) {
    activate(parent, target, item.previousElementSibling)
  }
}

/**
 * Here is where the roving tabindex magic happens!
 * @param {HTMLElement} parent
 * @param {string} target
 * @param {HTMLElement} item
 */
function activate (parent, target, elementSibling) {
  // Set all the target elements to tabindex -1
  parent.querySelectorAll(target).forEach(el => (el.tabIndex = -1))

  // Make the current target element to "active"
  elementSibling.tabIndex = 0
  elementSibling.focus()
}

export function storybookReady() {
  return new Promise((resolve) => {
    if (document.title === 'Storybook') {
      let intervId
      let t = () => {
        return setInterval(() => {
          if (document.getElementById('root').hasChildNodes()) {
            clearInterval(intervId)
            resolve(true)
          }
        }, 100)
      }
      intervId = t()
    } else {
      resolve(false)
    }
  })
}

export function disableFieldPresentMarkers(parent) {
  Array.from(parent.querySelectorAll('input[type="hidden"][value="on"]'))
      .filter(el => (el.name.startsWith('_')))
      .forEach(el => (el.disabled = true))
}

export function mediaNotSmall() {
  return window.matchMedia('(min-width: 48em)').matches
}

export function cumulativeOffset(element) {
  let top = 0, left = 0
  do {
    top += element.offsetTop  || 0
    left += element.offsetLeft || 0
    element = element.offsetParent
  } while (element)

  return {
    top: top,
    left: left
  }
}

// https://www.quirksmode.org/js/cookies.html#script
export function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}

export function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

export function eraseCookie(name) {
	createCookie(name,"",-1);
}
